const d = (o) => {
  const [r, e, t, a, n, s, i] = o;
  return {
    name: r,
    regions: e,
    iso2: t,
    dialCode: a,
    format: n,
    priority: s,
    areaCodes: i
  };
};
export {
  d as parseCountry
};
